import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { Link as RRLink } from 'react-router-dom';
import { CSSTransitionGroup } from 'react-transition-group';
import { colors } from '../styles';

const stepTime = 7;

const styles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: auto;
  background-color: ${colors.brand1};
  z-index: 50;
  .FooterPromoBanner {
    list-style: none;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 25px 15px;
    position: relative;
    width: fit-content;
    max-width: 800px;
    margin: 0;
  }
  .FooterPromoBanner_headline {
    p {
      font-size: 16px;
      font-weight: 700;
      line-height: 1;
      color: ${colors.white};
      margin: 0;
    }
  }
  .FooterPromoBanner_link {
    color: ${colors.black};
    font-size: 14px;
    line-height: 1;
    font-weight: 400;
    margin: 0 0 0 8px;
    text-decoration: underline;
    flex-shrink: 0;
  }
  .FooterPromoBanner_animation-enter {
    opacity: 0;
    transform: translateY(100%);
  }

  .FooterPromoBanner_animation-enter-active {
    opacity: 1;
    transition: all 250ms ease-in;
    transform: translateY(0);
    transition-delay: 500ms;
  }

  .FooterPromoBanner_animation-leave {
    position: absolute;
    opacity: 1;
  }

  .FooterPromoBanner_animation-leave-active {
    opacity: 0;
    transform: translateY(100%);
    transition: opacity 250ms ease-in, transform 250ms ease-in;
  }
  .FooterPromoBanner_close {
    width: 22px;
    height: 22px;
    background-color: ${colors.brand3Darkest};
    border-radius: 50%;
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
    transition: all .3s ease;
    @media(min-width: 992px) {
      right: 15px;
      top: 8px;
      left: auto;
    }
    &::after, &::before {
      position: absolute;
      left: 10px;
      top: 4px;
      content: ' ';
      height: 13px;
      width: 2px;
      background-color: #FFFFFF;
    }
    &::before {
      transform: rotate(45deg);
    }
    &::after {
      transform: rotate(-45deg);
    }
    &:focus {
      outline: none;
    }
    &:hover {
      background-color: ${colors.color1Darkest};
      transform: scale(1.1);
      transition: all .2s ease;
    }
  }
`;

class FooterPromoBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      slide: 0,
      hover: false,
      showPromo: true,
    };
  }

  componentDidMount() {
    this.startInterval();
    this.checkingPromoSession();
  }

  componentWillUnmount() {
    this.stopInterval();
  }

  onMouseEnterHandler = () => {
    this.setState({
      hover: true,
    });
    this.stopInterval();
  }

  onMouseLeaveHandler = () => {
    this.setState({
      hover: false,
    });
    this.startInterval();
  };

  stopInterval() {
    clearInterval(this.interval);
    this.interval = undefined;
  }

  startInterval() {
    if (!this.interval) {
      this.interval = setInterval(this.nextSlide, stepTime * 1000);
    }
  }
  nextSlide = () => {
    const { slide, hover } = this.state;
    const banners = get(this.props.widget, 'banners', []).filter(item => get(item, 'publish_in_footer'));
    if (!hover && slide + 1 >= banners.length) {
      this.setState({ slide: 0 });
    } else if (!hover) {
      this.setState({ slide: this.state.slide + 1 });
    }
  }
  checkingPromoSession = () => {
    if (sessionStorage.getItem('showPromo')) {
      this.setState({ showPromo: false });
    } else {
      this.setState({ showPromo: true });
    }
  }
  closePromoBanner = () => {
    this.setState({ showPromo: false });
    sessionStorage.setItem('showPromo', false);
  }

  render() {
    const { slide, showPromo } = this.state;
    const { widget } = this.props;
    const banners = get(widget, 'banners', []).filter(item => get(item, 'publish_in_footer'));
    const promo = banners[slide];
    if (!showPromo || banners.length === 0) {
      return null;
    }
    return (
      <CSSTransitionGroup
        className={styles}
        onMouseEnter={this.onMouseEnterHandler}
        onMouseLeave={this.onMouseLeaveHandler}
        transitionName="FooterPromoBanner_animation"
        transitionEnterTimeout={750}
        transitionLeaveTimeout={500}
      >
        <span className="FooterPromoBanner_close" role="button" tabIndex={0} onClick={this.closePromoBanner} />
        <div className="FooterPromoBanner" key={promo._id}>
          <div className="FooterPromoBanner_headline" dangerouslySetInnerHTML={SanitizeHtml(get(promo, 'headline'))} />
          <RRLink className="FooterPromoBanner_link" to={get(promo, 'button_link')}>{get(promo, 'button_text')}</RRLink>
        </div>
      </CSSTransitionGroup>
    );
  }
}

FooterPromoBanner.propTypes = {
  widget: PropTypes.object.isRequired,
};

export default withData(
  {
    widget: 'promo_banners',
  },
)(FooterPromoBanner);



// WEBPACK FOOTER //
// ./src/components/FooterPromoBanner.js